import React, { useState, useEffect } from "react";
import axios from "axios";
import { Trash, EditIcon, AddIcon, TrashWhite } from "../../assets/icons/icons";
import Pagination from "../section/Pagination";
import CustomAlert from "../CustomAlert";

export default function ManageAccessoriesCategory() {
  const [categories, setCategories] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [alert, setAlert] = useState(null);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [showDeleteSelectedDialog, setShowDeleteSelectedDialog] = useState(false);
  const [categoryUpdated, setCategoryUpdated] = useState(false);

  useEffect(() => {
    axios
      .get("https://laravel-api.aj-mart.com/api/accessoriesCategory")
      .then((response) => {
        // نتأكد من الحصول على مصفوفة صحيحة
        setCategories(response.data.accessories_category || []);
      })
      .catch((error) => {
        console.error("Error fetching accessories categories", error);
        setAlert({ type: "error", message: "Error fetching accessories categories" });
      });
  }, [categoryUpdated]);
  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
  }, []);
  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    try {
      const response = await axios.post(
        "https://laravel-api.aj-mart.com/api/accessoriesCategory/add",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      setCategories([...categories, response.data.category]);
      setAlert({ type: "success", message: "Accessories category added successfully" });
      setCategoryUpdated((prev) => !prev);
      event.target.reset();
    } catch (error) {
      console.error("Error adding accessories category", error);
      setAlert({ type: "error", message: "Error adding accessories category" });
    }
  };

  const handleEditClick = (data) => {
    setEditData(data);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditData({});
  };

  const handleSaveChanges = async () => {
    if (!editData.accessories_category_id) {
      setAlert({ type: "error", message: "No category selected for updating" });
      return;
    }
    const formData = new FormData();
    formData.append("accessories_category_name_E", editData.accessories_category_name_E);
    formData.append("accessories_category_name_A", editData.accessories_category_name_A);
    formData.append("accessories_category_tags", editData.accessories_category_tags);

    try {
      const response = await axios.post(
        `https://laravel-api.aj-mart.com/api/accessoriesCategory/update/${editData.accessories_category_id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "X-HTTP-Method-Override": "PUT",
          },
        }
      );
      if (response.data.success || response.data.message === "Accessories category updated successfully") {
        setAlert({ type: "success", message: "Accessories category updated successfully" });
        setCategoryUpdated((prev) => !prev);
        handleCloseModal();
      } else {
        let errorMessage = "Error updating category";
        if (response.data.errors) {
          errorMessage += "\n" + Object.values(response.data.errors).flat().join("\n");
        } else if (response.data.message) {
          errorMessage = response.data.message;
        }
        setAlert({ type: "error", message: errorMessage });
      }
    } catch (error) {
      console.error("Error updating accessories category", error);
      setAlert({ type: "error", message: "An unexpected error occurred while updating category" });
    }
  };

  const handleSelectCategory = (id) => {
    setSelectedCategories((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleSelectAll = () => {
    if (selectedCategories.length === categories.length) {
      setSelectedCategories([]);
    } else {
      setSelectedCategories(categories.map((cat) => cat.accessories_category_id));
    }
  };

  const handleDeleteCategory = (id) => {
    setShowDeleteDialog({ id });
  };

  const confirmDeleteCategory = async (id) => {
    try {
      await axios.delete(`https://laravel-api.aj-mart.com/api/accessoriesCategory/delete/${id}`);
      setCategories(categories.filter((cat) => cat.accessories_category_id !== id));
      setAlert({ type: "success", message: "Accessories category deleted successfully" });
      setShowDeleteDialog(false);
    } catch (error) {
      console.error("Error deleting accessories category", error);
      setAlert({ type: "error", message: "Error deleting accessories category" });
      setShowDeleteDialog(false);
    }
  };

  const handleDeleteSelectedCategories = () => {
    if (selectedCategories.length === 0) {
      setAlert({ type: "error", message: "Please select at least one category to delete" });
      return;
    }
    setShowDeleteSelectedDialog(true);
  };

  const confirmDeleteSelectedCategories = async () => {
    try {
      await Promise.all(
        selectedCategories.map((id) =>
          axios.delete(`https://laravel-api.aj-mart.com/api/accessoriesCategory/delete/${id}`)
        )
      );
      setCategories(categories.filter((cat) => !selectedCategories.includes(cat.accessories_category_id)));
      setAlert({ type: "success", message: "Selected accessories categories deleted successfully" });
      setSelectedCategories([]);
      setShowDeleteSelectedDialog(false);
    } catch (error) {
      console.error("Error deleting selected accessories categories", error);
      setAlert({ type: "error", message: "Error deleting selected accessories categories" });
      setShowDeleteSelectedDialog(false);
    }
  };

  return (
    <section className="py-[25px]">
      {alert && <CustomAlert type={alert.type} message={alert.message} onClose={() => setAlert(null)} />}

      <div className="main-title mb-[20px]">Manage Accessories Categories</div>
      <div className="mb-[30px]">
        <form onSubmit={handleSubmit}>
          <div className="flex flex-col gap-[10px]">
            <div className="flex flex-col gap-[5px] w-[49%]">
              <label className="text-black">Category Name In English</label>
              <input
                name="accessories_category_name_E"
                type="text"
                className="px-[15px] py-[7px] outline-none border-2 border-[#1485a6] rounded-[4px] text-black bg-[#eeeeee6e]"
                placeholder="Category Name In English"
                required
              />
            </div>
            <div className="flex flex-col gap-[5px] w-[49%]">
              <label className="text-black">Category Name In Arabic</label>
              <input
                name="accessories_category_name_A"
                type="text"
                className="px-[15px] py-[7px] outline-none border-2 border-[#1485a6] rounded-[4px] text-black bg-[#eeeeee6e]"
                placeholder="Category Name In Arabic"
                required
              />
            </div>
            <div className="flex flex-col gap-[5px] w-[49%]">
              <label className="text-black">Tags For Filter</label>
              <input
                name="accessories_category_tags"
                type="text"
                className="px-[15px] py-[7px] outline-none border-2 border-[#1485a6] rounded-[4px] text-black bg-[#eeeeee6e]"
                placeholder="Tags For Filter"
              />
            </div>
            <button type="submit" className="btn flex items-center gap-[5px]">
              <AddIcon />
              <span>Add a Category</span>
            </button>
          </div>
        </form>
      </div>

      <div className="flex justify-end items-center gap-[10px] capitalize mb-[20px]">
        <button
          className="btn bg-red-500 hover:bg-red-600 flex items-center gap-2"
          onClick={handleDeleteSelectedCategories}
        >
          <TrashWhite />
          <span>Delete Selected Categories</span>
        </button>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-200 text-left">
          <thead className="bg-gray-100">
            <tr>
              <th className="border border-gray-200 p-[10px] capitalize">
                <input
                  type="checkbox"
                  className="w-[18px] h-[18px]"
                  checked={selectedCategories.length === categories.length}
                  onChange={handleSelectAll}
                />
              </th>
              <th className="border border-gray-200 p-[10px] capitalize">Category Name In English</th>
              <th className="border border-gray-200 p-[10px] capitalize">Category Name In Arabic</th>
              <th className="border border-gray-200 p-[10px] capitalize">Tags For Filter</th>
              <th className="border border-gray-200 p-[10px] capitalize">Actions</th>
            </tr>
          </thead>
          <tbody>
            {categories
              .filter((cat) => cat && cat.accessories_category_id)
              .map((cat) => (
                <tr key={cat.accessories_category_id} className="bg-white hover:bg-gray-50">
                  <td className="border border-gray-200 p-[10px]">
                    <input
                      type="checkbox"
                      className="w-[18px] h-[18px]"
                      checked={selectedCategories.includes(cat.accessories_category_id)}
                      onChange={() => handleSelectCategory(cat.accessories_category_id)}
                    />
                  </td>
                  <td className="border border-gray-200 p-[10px]">{cat.accessories_category_name_E}</td>
                  <td className="border border-gray-200 p-[10px]">{cat.accessories_category_name_A}</td>
                  <td className="border border-gray-200 p-[10px]">{cat.accessories_category_tags}</td>
                  <td className="border border-gray-200 p-[10px]">
                    <div className="flex items-center gap-3">
                      <div className="cursor-pointer" onClick={() => handleEditClick(cat)}>
                        <EditIcon />
                      </div>
                      <div className="cursor-pointer" onClick={() => handleDeleteCategory(cat.accessories_category_id)}>
                        <Trash />
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      <Pagination />

      {/* Edit Modal */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white w-[500px] rounded-lg shadow-lg p-[20px] relative">
            <h2 className="text-xl font-bold mb-[10px]">Edit Category</h2>
            <div className="flex flex-col gap-[10px] capitalize">
              <label className="text-sm font-medium">
                Category Name In English
                <input
                  type="text"
                  className="block w-full mt-1 p-[10px] capitalize border rounded"
                  value={editData.accessories_category_name_E || ""}
                  onChange={(e) =>
                    setEditData({ ...editData, accessories_category_name_E: e.target.value })
                  }
                  required
                />
              </label>
              <label className="text-sm font-medium">
                Category Name In Arabic
                <input
                  type="text"
                  className="block w-full mt-1 p-[10px] capitalize border rounded"
                  value={editData.accessories_category_name_A || ""}
                  onChange={(e) =>
                    setEditData({ ...editData, accessories_category_name_A: e.target.value })
                  }
                  required
                />
              </label>
              <label className="text-sm font-medium">
                Tags For Filter
                <input
                  type="text"
                  className="block w-full mt-1 p-[10px] capitalize border rounded"
                  value={editData.accessories_category_tags || ""}
                  onChange={(e) =>
                    setEditData({ ...editData, accessories_category_tags: e.target.value })
                  }
                />
              </label>
            </div>
            <div className="flex justify-end gap-3 mt-[20px]">
              <button className="btn bg-gray-300 hover:bg-gray-400" onClick={handleCloseModal}>
                Cancel
              </button>
              <button className="btn bg-green-500 hover:bg-green-600" onClick={handleSaveChanges}>
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Dialog */}
      {showDeleteDialog && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white w-[400px] rounded-lg shadow-lg p-[20px] relative">
            <h2 className="text-xl font-bold mb-[10px]">Confirm Deletion</h2>
            <p className="text-sm mb-[20px]">
              Are you sure you want to delete this accessories category?
            </p>
            <div className="flex justify-end gap-3">
              <button className="btn bg-gray-300 hover:bg-gray-400" onClick={() => setShowDeleteDialog(false)}>
                Cancel
              </button>
              <button className="btn bg-red-500 hover:bg-red-600" onClick={() => confirmDeleteCategory(showDeleteDialog.id)}>
                Confirm Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Selected Confirmation Dialog */}
      {showDeleteSelectedDialog && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white w-[400px] rounded-lg shadow-lg p-[20px] relative">
            <h2 className="text-xl font-bold mb-[10px]">Confirm Deletion</h2>
            <p className="text-sm mb-[20px]">
              Are you sure you want to delete the selected accessories categories?
            </p>
            <div className="flex justify-end gap-3">
              <button className="btn bg-gray-300 hover:bg-gray-400" onClick={() => setShowDeleteSelectedDialog(false)}>
                Cancel
              </button>
              <button className="btn bg-red-500 hover:bg-red-600" onClick={confirmDeleteSelectedCategories}>
                Confirm Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
